import { Field } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { JobWorkingForm } from '../../../types'
import { CheckboxGroup } from '../../organisms/CheckboxGroup'

export const WorkingFormCheckboxField: FC = () => {
  const { t } = useTranslation(['jobs'])

  return (
    <CheckboxGroup>
      <label>
        <Field type='checkbox' name='workingForm' value={JobWorkingForm.IN_OFFICE_ONLY} />
        {t(JobWorkingForm.IN_OFFICE_ONLY)}
      </label>
      <label>
        <Field type='checkbox' name='workingForm' value={JobWorkingForm.REMOTE_ACCEPTED} />
        {t(JobWorkingForm.REMOTE_ACCEPTED)}
      </label>
      <label>
        <Field type='checkbox' name='workingForm' value={JobWorkingForm.REMOTE_ONLY} />
        {t(JobWorkingForm.REMOTE_ONLY)}
      </label>
    </CheckboxGroup>
  )
}
